// extracted by mini-css-extract-plugin
export default {"center":"Loader_center__e7Fjz","logoSpin":"Loader_logoSpin__X4GO7","logo-spin":"Loader_logo-spin__mCd1H"};